import {
  getLoanDetailsAPI,
  addLoanDetailsAPI,
  updateLoanDetailsAPI,
  deleteLoanDetailsAPI
} from '../adapter/adapter'

export function getAllLoansHelper() {
  let promise = new Promise(function (resolve, reject) {
    getLoanDetailsAPI()
      .then((res) => {
        console.log('getAllLoansHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get Loans Failure')
        }
      })
      .catch((err) => {
        console.log('getAllLoansHelper err: ', err)
        reject('Get Loans Failure')
      })
  })

  return promise
}

export function addLoanHelper(data) {
  let reqData = {
    lender_name: data.lender_name,
    loan_amount: parseFloat(data.loan_amount),
    tenure_months: parseInt(data.tenure_months),
    interest_rate: parseFloat(data.interest_rate),
    monthly_interest_rate: parseFloat(data.monthly_interest_rate),
    monthly_installment: parseFloat(data.monthly_installment),
    installment_start_date: data.installment_start_date,
    installment_end_date: data.installment_end_date,
    outstanding_balance: parseFloat(data.outstanding_balance)
  }

  let promise = new Promise(function (resolve, reject) {
    addLoanDetailsAPI(reqData)
      .then((res) => {
        console.log('addLoanHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Add Loan Failure')
        }
      })
      .catch((err) => {
        console.log('addLoanHelper err: ', err)
        reject('Add Loan Failure')
      })
  })

  return promise
}

export function updateLoanHelper(data) {
  let reqData = {
    id: data.id,
    lender_name: data.lender_name,
    loan_amount: parseFloat(data.loan_amount),
    tenure_months: parseInt(data.tenure_months),
    interest_rate: parseFloat(data.interest_rate),
    monthly_interest_rate: parseFloat(data.monthly_interest_rate),
    monthly_installment: parseFloat(data.monthly_installment),
    installment_start_date: data.installment_start_date,
    installment_end_date: data.installment_end_date,
    outstanding_balance: parseFloat(data.outstanding_balance)
  }

  let promise = new Promise(function (resolve, reject) {
    updateLoanDetailsAPI(reqData)
      .then((res) => {
        console.log('updateLoanHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Update Loan Failure')
        }
      })
      .catch((err) => {
        console.log('updateLoanHelper err: ', err)
        reject('Update Loan Failure')
      })
  })

  return promise
}

export function deleteLoanHelper(id) {
  let reqData = {
    id: id
  }

  let promise = new Promise(function (resolve, reject) {
    deleteLoanDetailsAPI(reqData)
      .then((res) => {
        console.log('deleteLoanHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.code === 200) {
          resolve(true)
        } else {
          reject('Delete Loan Failure')
        }
      })
      .catch((err) => {
        console.log('deleteLoanHelper err: ', err)
        reject('Delete Loan Failure')
      })
  })

  return promise
}

